import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { ISnFormStep } from '@lib/form';
import { SnGoogleGeocoderResult } from '@lib/geo/google/geocoder';
import { t } from '@lib/translation';

import { SnLocationFieldsGeneratorService } from './../../services/location-fields-generator.service';

@Component({
  templateUrl: './confirm-location-place-dialog.component.html',
  styleUrls: ['./confirm-location-place-dialog.component.scss'],
})
export class ConfirmLocationPlaceDialogComponent implements OnInit {
  public formModel = {};
  public form: UntypedFormGroup = new UntypedFormGroup({});
  public readonly formDataStep: ISnFormStep = {
    label: '',
    fields: [
      {
        templateOptions: {
          label: t('locations.fields.place'),
        },
        wrappers: ['form-field-group'],
        fieldGroup: [
          this._locationFieldsGenerator.getAddressField({
            templateOptions: {
              required: true,
              change: (field, place) => this._updateGeometry(place),
              autocompleteOn: false,
            },
          }),
          this._locationFieldsGenerator.getCityField({
            templateOptions: {
              required: true,
            },
          }),
          {
            fieldGroupClassName: 'location-row',
            fieldGroup: [
              this._locationFieldsGenerator.getStateField({
                className: 'location-col',
                templateOptions: {
                  required: true,
                },
              }),
              this._locationFieldsGenerator.getZipField({
                className: 'location-col',
                templateOptions: {
                  required: true,
                },
              }),
            ],
          },
        ],
      },
    ],
  };

  constructor(
    private readonly _locationFieldsGenerator: SnLocationFieldsGeneratorService,
    private readonly _dialogRef: MatDialogRef<ConfirmLocationPlaceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SnGoogleGeocoderResult,
  ) {
    this.formModel = {
      ...this.formModel,
      address: data.addressComponents.address,
      city: data.addressComponents.city,
      state: data.addressComponents.state,
      zip: data.addressComponents.zip,
    };
  }

  public ngOnInit(): void {}

  public submitForm(): void {
    this._dialogRef.close(this.data);
  }

  private _updateGeometry(place: SnGoogleGeocoderResult): void {
    if (!place.geometry) {
      return;
    }

    this.form.patchValue({
      city: place.addressComponents.city,
      state: place.addressComponents.state,
      zip: place.addressComponents.zip,
    });
  }
}
